import type { WidgetDefinition } from './types';

export const RELEASED_WIDGETS: ReadonlySet<string> = new Set([
  'cash.position',
  'cash.accounts',
  'cash.evolution',
  'cash.daily-movement',
  'cash.by-institution',
  'cash.by-group',
  'cash.idle-vs-invested',
  'cash.stale-accounts',
  'cash.limit-breaches',
  'cash.forecast',
  'flow.outlook',
  'investments.portfolio',
  'investments.liquidity',
  'investments.cdi',
  'investments.expirations',
  'investments.performance',
  'investments.low-performance',
  'investments.diversification',
  'investments.by-institution',
  'debts.portfolio',
  'debts.upcoming',
  'debts.service',
  'tariffs.cost',
  'tariffs.by-bank',
  'tariffs.evolution',
  'tariffs.top-fees',
  'transfers.failures',
  'links.health',
  'links.certificates',
  'policies.compliance',
  'policies.breaches',
  'policies.uptime',
  'policies.rating-exposure',
  'policies.rating-expiry',
  'reports.favourites',
  'closing.coverage',
]);

export const isReleased = (definition: WidgetDefinition): boolean => RELEASED_WIDGETS.has(definition.id);
